import { useState } from "react";
import StarRatingComponent from "react-star-rating-component";
import { StarIcon } from "@heroicons/react/20/solid";

interface StarRatingProps {
  initialRate?: number;
  starClick: (rate: number) => void;
  className?: string;
  starColor?: string;
  emptyStarColor?: string;
  size?: number;
}

const StarRating = ({
  initialRate = 0,
  starClick,
  className = "",
  starColor = "#ffd700",
  emptyStarColor = "#ddd",
  size = 30,
}: StarRatingProps) => {
  const [rate, setRate] = useState(initialRate);

  const onClickHandler = (rateValue: number) => {
    setRate(rateValue);
    starClick(rateValue);
  };

  return (
    <div
      className={className}
      role="img"
      aria-label={`Rating: ${rate} out of 5 stars`}
    >
      <StarRatingComponent
        name="rating"
        starCount={5}
        value={rate}
        onStarClick={onClickHandler}
        starColor={starColor}
        emptyStarColor={emptyStarColor}
        renderStarIcon={() => (
          <StarIcon
            style={{
              width: `${size}px`,
              height: `${size}px`,
              padding: "2px",
            }}
          />
        )}
      />
    </div>
  );
};

export default StarRating;
